import { LoginTopLeft } from "@/assets/svg/loginTopLeft";
import Button from "@/common/atoms/Button";
import PaymentRadioButton from "@/common/atoms/Button/AppPaymentRadioButton";
import { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  reset,
  subscriptionPaymentRequest
} from "@/features/property/duck/subscription";
import { ErrorAlert } from "@/common/atoms";
import { hideModal } from "@/store/slices/modalSlice";
import "./PaymentListings.scss";
import { useTranslation } from "react-i18next";
import { useLanguage } from "@/hook/useLanguage";
import { getConfig } from "@/get-config";

const ListingFeature = ({ propertyId }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { isRTL } = useLanguage();

  const { cdnAssetUrl } = getConfig();
  const listingBg = `${cdnAssetUrl}listing-bg.webp`;

  const { userInfo, loadingPayment, featureAddPlan, checkout_url, error } =
    useSelector(
      (state) => ({
        userInfo: state.user.userInfo,
        loadingPayment: state.subscription.loadingPayment,
        featureAddPlan: state.subscription.featureAddPlan,
        checkout_url: state.subscription.checkout_url,
        error: state.subscription.error
      }),
      shallowEqual
    );

  const [selected, setSelected] = useState(featureAddPlan[0]?.value);

  const handleContinuePayment = () => {
    dispatch(
      subscriptionPaymentRequest({
        userId: userInfo.uuid,
        propertyId,
        featuredAdPlanId: selected
      })
    );
  };

  useEffect(() => {
    return () => {
      dispatch(reset());
    };
  }, []);

  const closeModal = () => {
    dispatch(hideModal());
  };

  useEffect(() => {
    if (checkout_url) {
      window.open(checkout_url, "_self", "noopener,noreferrer");
      closeModal();
    }
  }, [checkout_url]);

  return (
    <div className="flex justify-center w-full">
      <div className=" w-full relative">
        <div className={`absolute top-0 ${isRTL ? "right-0" : "left-0"}`}>
          <LoginTopLeft />
        </div>
        <div
          className={`w-full lg:w-[550px] ${
            isRTL ? "pr-8 py-12" : "pl-8 py-8"
          }`}>
          <h1 className="text-4xl sm:text-4xl md:text-5xl xl:text-7xl font-kindAvenue text-secondary mb-5">
            {t("payment.standOutTitle")}
          </h1>
          <p className=" text-sm sm:text-sm md:text-sm xl:text-sm text-secondary my-3 pr-3">
            {t("payment.standOutDescription")}
          </p>
          <div className={`xl:w-[350px] ${isRTL ? "ml-6" : "mr-6"}`}>
            {error && <ErrorAlert error={error} />}
            <PaymentRadioButton
              options={featureAddPlan}
              value={selected}
              onChange={(value) => setSelected(value.target.value)}
            />
          </div>
          <Button
            loading={loadingPayment}
            disabled={checkout_url}
            className="mt-8 w-1/2 lg:w-1/3 py-2 h-[54px]"
            onClick={handleContinuePayment}>
            {t("common.continue")}
          </Button>
        </div>
      </div>
      <div
        className={`relative w-full hidden xl:block overflow-hidden ${
          isRTL ? "mr-1" : "ml-1"
        }`}>
        <img
          alt="Modern house with large glass windows and a pool in front"
          src={listingBg}
          width={"100%"}
          height={"100%"}
          className="
            rounded-tr-lg
            rounded-br-lg
            absolute
            top-0
            left-0
            w-full
            h-full
            object-fill
            object-center"
          loading="lazy"
        />
        <div className="absolute bottom-2 right-2 text-white">
          <a onClick={closeModal} className="text-white text-sm font-semibold">
            {t("common.skip")} &gt;&gt;
          </a>
        </div>
      </div>
    </div>
  );
};

export default ListingFeature;
